import React from "react";
import { Skeleton as RPSkeleton } from "primereact/skeleton";
import { User } from "../../../client";
import { displayNameForUser } from "../../../util";
import { DashboardReportCard } from "./DashboardReportCard";
import { GroupedRowData, isLoadingState, LoadedReportRow } from "./rowTypes";
import { statusIsClosedOrDeclined } from "./util";
import styles from "./MobileReportList.module.css";

export const MobileReportList = ({
  rows,
  users,
  showGroupHeaders,
  grayOutDeclined,
  onSelect,
}: {
  rows: GroupedRowData[];
  users: User[];
  showGroupHeaders: boolean;
  grayOutDeclined: boolean;
  onSelect: (reportId: string) => void;
}) => {
  if (rows.length > 0 && rows.every(isLoadingState)) {
    return (
      <div className={styles.mobileList}>
        {rows.map((_, index) => (
          <RPSkeleton key={index} height="96px" borderRadius="8px" />
        ))}
      </div>
    );
  }

  const reports = rows.filter(
    (row): row is LoadedReportRow => !isLoadingState(row)
  );

  if (reports.length === 0) {
    return <div className={styles.mobileEmpty}>No results found</div>;
  }

  const groups: { label: string | undefined; reports: LoadedReportRow[] }[] =
    [];
  for (const report of reports) {
    const label = showGroupHeaders ? report.__group : undefined;
    let group = groups.find((g) => g.label === label);
    if (!group) {
      group = { label, reports: [] };
      groups.push(group);
    }
    group.reports.push(report);
  }
  for (const group of groups) {
    group.reports.sort((a, b) =>
      b.created_at_ts.localeCompare(a.created_at_ts)
    );
  }

  return (
    <div className={styles.mobileList}>
      {groups.map((group) => (
        <React.Fragment key={group.label ?? "__ungrouped"}>
          {group.label && (
            <div className={styles.mobileGroupHeader}>{group.label}</div>
          )}
          {group.reports.map((report) => {
            const assignee = users.find((u) => u.id === report.assignee);
            return (
              <DashboardReportCard
                key={report.report_id}
                report={report}
                assigneeLabel={displayNameForUser(assignee)}
                assigneeImageUrl={assignee?.profile_image_url}
                declined={
                  grayOutDeclined && statusIsClosedOrDeclined(report.status)
                }
                onClick={() => onSelect(report.report_id)}
              />
            );
          })}
        </React.Fragment>
      ))}
    </div>
  );
};
